import { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Home from "../Home/Home";
import {  useNavigate } from "react-router-dom";
import { useGlobalContext } from "../LoginPage/GlobalContext";

const api_url = process.env.REACT_APP_API_URL;

const PurchaseList = () => {
  const navigate = useNavigate();

  //   const { faqId, setFaqId  } = useGlobalContext();

  const [purchaseData, setPurchaseData] = useState([]);

  const [view, setView] = useState(false);
  //   const [update, setUpdate] = useState(false);
  // const [create, setCreate] = useState(false);

  const [profileData, setProfileData] = useState([]);

  //   const onEditClick = (_id) => {
  //     setFaqId(_id);
  //     navigate("/editfaq");
  //   };

  useEffect(() => {
    fetch(`${api_url}/getuser`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const userObject = data.find(
          (user) => user._id === sessionStorage.userId
        );
        // setIsValidUser(userObject.active);
        if (!userObject.active) {
          navigate("/");
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const profilesDataFetcher = async () => {
      try {
        const response3 = await fetch(`${api_url}/getprofiles`);
        if (!response3.ok) {
          throw new Error(`HTTP error! Status:${response3.status}`);
        }
        const resData3 = await response3.json();
        const UserProfileData = resData3.filter(
          (profile) => profile.profileName === sessionStorage.userProfile
        );
        setProfileData(UserProfileData);
        setView(UserProfileData[0].status.purchases.view);
        // setCreate(UserProfileData[0].status.review.create);
      } catch (error) {
        console.error("Error fetching profiles data:", error);
      }
    };

    profilesDataFetcher();
  }, []);

  const getDateFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  useEffect(() => {
    fetch(`${api_url}/showpurchase`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setPurchaseData(data);
        // console.log("Data received from the server:", data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [profileData]);

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "clientEmail", //access nested data with dot notation
        header: "Client Email",
        size: 50,
      },
      {
        accessorKey: "clientPhone", //access nested data with dot notation
        header: "Client Phone",
        size: 50,
      },
      {
        accessorKey: "productIdentifier",
        header: "Product ID",
        size: 20,
      },
      {
        accessorKey: "createdAt",
        header: "Purchase Date",
        size: 15,
        accessorFn: (row) => getDateFormat(row.createdAt),
      },
    ],
    [profileData]
  );

  const table = useMaterialReactTable({
    columns,
    data: purchaseData, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    // initialState: { e: false },
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    enableHiding: false,
    paginationDisplayMode: "pages",
    muiTablePaperProps: {
      elevation: 0,
    },
    globalFilterFn: "contains",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  });

  return (
    <div>
      <Home />
      {view && (
        <div>
          <div className="table-button-container">
            {/* {create && (
              <div className="niveshartha-btn-container">
                <Link to="/addMarquee">
                  <button className="niveshartha_btn_add">Add Marquee</button>
                </Link>
              </div>
            )} */}
            <div className="user-table-container">
              <MaterialReactTable table={table} />
            </div>
          </div>
        </div>
      )}
      {!view && (
        <div className="user-table-container loading-gif">
          <img src="/loading.gif" alt="loading"></img>
        </div>
      )}
    </div>
  );
};

export default PurchaseList;
